import { FC, useEffect } from "react";
import { ESRState } from "../types/data";
import { useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import { Button } from "@mui/material";

export const NotificationMessage: FC = () => {
	const open_notifications = useSelector(
		(state: ESRState) => state.open_notifications,
	);

	const { enqueueSnackbar, closeSnackbar } = useSnackbar();
	useEffect(() => {
		if (open_notifications !== undefined && open_notifications.length > 0) {
			for (const [index, notif] of open_notifications.entries()) {
				const isUIRecipient = notif?.recipient === "UI" || notif?.recipient === "UI-warning";
				let snackBarVariant: "success" | "default" | "error" | "warning" | "info" = "success"
				if (notif?.recipient === "UI") snackBarVariant = "info"
				if (notif?.recipient === "UI-warning") snackBarVariant = "warning"
				enqueueSnackbar({
					key: String(index),
					variant: snackBarVariant,
					message: 
					isUIRecipient
                    ? `Message: ${notif?.notification}`
                    : `Message: ${notif?.notification}\nSend to: ${notif?.recipient}`,

					action: (key) => (
						<Button
							sx={{ color: "white" }}
							onClick={() => {
								closeSnackbar(key);
							}}
						>
							Done
						</Button>
					),
				});
			}
		}
	}, [open_notifications]);

	return null;
};